import React from 'react';
import Header from '../components/layout/headers/Header'
import DynamicDashboard from "../components/layout/dashboard/DynamicDashboard"
import DynamicNavigation from "../components/layout/navigation/DynamicNavigation"

const Dashboard = () => {
    return (
        <>
            <Header />
            <DynamicNavigation/>
            <DynamicDashboard/>
        </>
    );
};

export default Dashboard;